module.exports = __webpack_public_path__ + "img/more.4fbfa1ba.svg";